import { api } from "../../lib/api";
const patchAssetAction = async (projectId, assetId, operationType, queryParams = {}) => {
    const params = new URLSearchParams({ operationType });
    if (queryParams.partyNumber)
        params.append("partyNumber", queryParams.partyNumber);
    if (queryParams.downSelectPartyNumber)
        params.append("downSelectPartyNumber", queryParams.downSelectPartyNumber);
    const { data } = await api.patch(`/projects/${projectId}/assets?${params.toString()}`, {
        assetDetails: [{ assetId }]
    });
    return data;
};
export const deleteAssetFromSite = (projectId, assetId, queryParams = {}) => patchAssetAction(projectId, assetId, "delete", queryParams);
export const ignoreAssetFromSite = (projectId, assetId, queryParams = {}) => patchAssetAction(projectId, assetId, "ignore", queryParams);
export const recoverAssetFromSite = (projectId, assetId, queryParams = {}) => patchAssetAction(projectId, assetId, "recover", queryParams);
